import React from 'react';
// import Chip from 'Chip';
import PropTypes from 'prop-types';
import styles from './index.css';
import { rel } from '../../../../../utils/rel';
import errorBoundary from '@ifeng/errorBoundary';

class BreadCrumb extends React.PureComponent {
    /**
     * 渲染网页布局
     */
    render() {
        const {
            headerData: { breadCrumbdata },
        } = this.props;

        return (
            <div className={styles.speNav}>
                {breadCrumbdata.map((item, index) => (
                    <span key={index}>
                        <a href={item.url} rel={rel} target="_blank">
                            {item.title}
                        </a>
                        {index === breadCrumbdata.length - 1 ? '' : ' > '}
                    </span>
                ))}
                {' > '}
                <span>正文</span>
            </div>
        );
    }
}

/**
 * 定义组件属性类型
 * */
BreadCrumb.propTypes = {
    headerData: PropTypes.object,
};

/**
 * 定义组件默认属性
 * */
BreadCrumb.defaultProps = {};

export { BreadCrumb };
export default errorBoundary(BreadCrumb);
